import TreatmentInfo from './TreatmentInfo'
export default TreatmentInfo
